// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2gy2g","dragIcon":"Choice_dragIcon__159C8","left":"Choice_left__2uPyO","input":"Choice_input__1chFc"};